// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + ".css?v=" + "3f9918e5dbd08bc7044f" + "";
};